import { type Experiment } from 'src/api/voisino/experiments.model'
import {
    SET_EXPERIMENTS,
    SET_LOADING,
    SET_ERROR,
    type VoisinoExperimentsState,
} from 'src/redux/voisinoExperiments/voisinoExperiments.types'
import { type VoisinoExperimentsAction } from 'src/redux/voisinoExperiments/voisinoExperiments.actions'

const INITIAL_STATE: VoisinoExperimentsState = {
    experiments: [],
    loading: false,
    error: null,
}

export function voisinoExperimentsReducer(
    state: VoisinoExperimentsState = INITIAL_STATE,
    action: VoisinoExperimentsAction,
): VoisinoExperimentsState {
    switch (action.type) {
        case SET_LOADING:
            return { ...state, loading: (action as any).payload as boolean }
        case SET_ERROR:
            return { ...state, error: (action as any).payload as string | null }
        case SET_EXPERIMENTS:
            return { ...state, experiments: (action as any).payload as Experiment[] }
        default:
            return state
    }
}
